import React from "react";
import { Dialog as HeadlessDialog, Transition } from "@headlessui/react";

function Dialog({ open, onOpenChange, children }) {
    return (
        <Transition show={open}>
            <HeadlessDialog
                open={open}
                onClose={onOpenChange}
                className="fixed inset-0 z-50 flex items-center justify-center overflow-auto bg-black/50"
            >
                <Transition.Child
                    enter="transition ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="transition ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                >
                    <div className="bg-white rounded-xl shadow-lg w-full max-w-md mx-auto p-6">
                        {children}
                    </div>
                </Transition.Child>
            </HeadlessDialog>
        </Transition>
    );
}

function DialogContent({ children, className }) {
    return <div className={`relative ${className}`}>{children}</div>;
}

function DialogTitle({ children }) {
    return <h2 className="text-lg font-semibold">{children}</h2>;
}

export function DialogComponent({ open, onOpenChange, title, icon, image, description, actions }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-sm">
                    {image ? (
                        <div className="flex flex-col items-center">
                            <img
                                src={`data:image/jpeg;base64,${image}`}
                                className="w-72 h-72 object-cover"
                                alt=""
                            />
                            <DialogTitle className="text-center flex items-center justify-center gap-2 mt-2">
                                {title}
                            </DialogTitle>
                        </div>
                    ) : (
                        <DialogTitle className="text-center flex items-center justify-center gap-2">
                            {icon}
                            {title}
                        </DialogTitle>
                    )}

                <div className="space-y-2 py-2">
                    {description}
                    {actions}
                </div>
            </DialogContent>
        </Dialog>
    );
}

